export default {
    ai: 'AI-assistent',
    export: 'Eksporter',
    blue: 'Blå',
    yellow: 'Gul',
    pink: 'Pink',
    orange: 'Orange',
    all: 'Alle',
    generateApaCopy: 'Generer APA-citat',
    apaCopied: 'Citat kopieret til udklipsholder!',
    imReading: 'Jeg læser',
    in: 'i',
    by: 'Af',
    article: 'Artikel',
    prevArticle: 'Forrige artikel',
    nextArticle: 'Næste artikel',
    imHere: 'Ja, jeg er her',
    sessionExpiredAlert: 'Din læsesession er ved at udløbe.',
    sessionExpiredAreYouThere: 'Er du der?',
    sessionExpired: 'Din læsesession er udløbet på grund af inaktivitet.',
    returnToLibrary: 'Tilbage til biblioteket',
    sessionValidExpired: 'Sessionen er udløbet',
    sessionValidExpiredPleaseLoginAgain: 'Log venligst ind igen',
    tableOfContents: 'Indholdsfortegnelse',
    tableOfContentsNotAvailable: 'Ingen indholdsfortegnelse tilgængelig.',
    pages: 'sider',
    page: 'side',
    thumbnails: 'Miniaturer',
    settings: 'Indstillinger',
    bookmarks: 'Bogmærker',
    highlights: 'Fremhævninger',
    highlight: 'Fremhævning',
    notes: 'Noter',
    note: 'Note',
    notebook: 'Notesbog',
    search: 'Søg',
    theme: 'Tema',
    readingModes: 'Læsetilstande',
    zoomTitle: 'Tekststørrelse',
    zoomTitlePdf: 'Zoom',
    zoomTimes: 'Times',
    typography: 'Typografi',
    fontDefault: 'Standard',
    lineSpacing: 'Linjeafstand',
    lineSpacingCompact: 'Kompakt',
    lineSpacingNormal: 'Normal',
    lineSpacingWide: 'Bred',
    margins: 'Margener',
    marginsMinimum: 'Minimum',
    marginsNormal: 'Normal',
    marginsMaximum: 'Maksimum',
    pageLayout: 'Sidelayout',
    continuous: 'Kontinuerlig',
    onePage: 'Horisontal',
    onePageScroll: 'Vertikal',
    twoPages: 'Dobbelt',
    twoPagesScroll: 'To sider rulning',
    citation: {
        buttons: {
            Iso690: 'Generer ISO690-citat',
            APA: 'Generer APA-citat',
            Vancouver: 'Generer Vancouver-citat',
            IEEE: 'Generer IEEE-citat',
            MLA: 'Generer MLA-citat',
            ABNT: 'Generer ABNT-citat',
        },
        menu: {
            title: 'Generer citat',
            Iso690: 'ISO 690',
            APA: 'APA',
            Vancouver: 'Vancouver',
            IEEE: 'IEEE',
            MLA: 'MLA',
            ABNT: 'ABNT',
        },
        messages: {
            copied: 'Citat kopieret til udklipsholder!',
            availableIn: 'Tilgængelig i',
            online: 'Internet',
            generated: 'citeret',
            websiteName: 'publica.la',
            and: 'og',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Forklar koncept',
            expand: 'Udvid information',
            summarize: 'Opsummer idé',
        },
        menu: {
            title: 'AI-assistent (Beta)',
        },
        messages: {
            copied: 'Svar kopieret til udklipsholder!',
            addedToResponse: '«Svar kopieret fra publica.la Reader»',
        },
        thanksFeedback: 'Tak for din feedback!',
        errorFeedback: 'Afsendelse af feedback mislykkedes. Kan du prøve igen?',
    },
    onlyCopy: 'Kopier almindelig tekst',
    translate: 'Oversæt',
    copy: 'kopier',
    changeColor: 'Skift farve',
    socialShare: 'Del',
    zoom: {
        auto: 'Auto',
        'page-fit': 'Tilpas side',
        'page-width': 'Sidebredde',
    },
    filter: 'Filter',
    noFilterHighlights: 'Vælg et filter for at se dine fremhævninger',
    noFilterHighlightsColor: 'Der er intet fremhævet i denne farve',
    noHighlights: 'Du har ikke lavet fremhævninger endnu',
    noFilterNotes: 'Vælg en farve for at se dine noter',
    noFilterNotesColor: 'Der er ingen noter i denne farve',
    noNotes: 'Du har ikke skrevet noter endnu',
    noFilterHighlightsAndNotes: 'Vælg en farve for at se dine fremhævninger og noter',
    noFilterHighlightsAndNotesColor: 'Der er ingen noter eller fremhævninger i denne farve',
    noHighlightsAndNotes: 'Du har ikke oprettet nogen fremhævninger eller noter endnu',
    plainCopied: 'Tekst kopieret til udklipsholder!',
    onboarding: {
        next: 'Næste',
        finish: 'Afslut',
        skip: 'Spring vejledning over',
        previous: 'Forrige',
        reader: {
            welcome: {
                title: 'Velkommen til dit læserum',
                paragraph: 'Opdag hvordan du får mest muligt ud af dine bøger med de tilgængelige værktøjer i læseren.',
                extraParagraph: 'Nyd dit nye læserum!',
            },
            highlights: {
                title: 'Forbedr din læseoplevelse',
                paragraph:
                    'Vælg tekst, fremhæv, opret noter, generer citater, oversæt og lyt til indholdet. Tag din læseoplevelse til næste niveau i alle formater.',
            },
            resumes: {
                title: 'Administrer dit indhold',
                paragraph:
                    'Øg din produktivitet. Administrer dine noter, fremhævninger, citater og resuméer efter behov. Del dine idéer hurtigt og nemt.',
            },
            appPromote: {
                title: 'Læs eller lyt hvor som helst',
                paragraph:
                    'Få adgang til dit indhold når og hvordan du vil, uden internetforbindelse, på den enhed du foretrækker.',
                extraParagraph: 'Download vores app!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Velkommen',
                subTitle: 'Hvordan bruger man lydafspilleren?',
                paragraph: 'Lær hvordan du får mest muligt ud af din lytning.',
            },
            reproduction: {
                title: 'Afspilningskontrol',
                paragraph: 'Spol frem og tilbage, eller sæt lydbogen på pause.',
            },
            narratorSpeed: {
                title: 'Oplæsningshastighed',
                paragraph: 'Du kan vælge den hastighed du foretrækker til lydbogen.',
            },
            chapters: {
                title: 'Kapitler',
                paragraph: 'Flyt mellem kapitler hurtigt og nemt.',
            },
        },
    },
    author: 'Forfatter',
    publisher: 'Udgiver',
    narrator: 'Oplæser',
    narratedBy: 'Oplæst af',
    aboutThisPublication: 'Om denne publikation',
    listening: {
        label: 'Lyt',
        voice: 'Stemme',
    },
    searchResultEmpty: 'Ingen resultater fundet',
    searchLengthError: 'Søgningen skal være mellem 4 og 128 tegn',
    keepTyping: 'Bliv ved med at skrive…',
    loading: 'Indlæser...',
    searchLoading: 'Søger...',
    searchTitle: 'Søg',
    lastSearch: 'Forslag',
    searchExplanation: 'Find ord hurtigt i hele publikationen',
    networkIsOffline: 'Ingen internetforbindelse tilgængelig. Nogle funktioner er utilgængelige.',
    about: 'Om',
    chapters: 'Kapitler',
    duration: 'Varighed',
    narratorSpeed: 'Oplæsningshastighed',
    slowNarration: 'Langsom oplæsning',
    normalNarration: 'Normal oplæsning',
    fastNarration: 'Hurtig oplæsning',
    shareIssue: 'Del publikation',
    shareArticle: 'Del artikel',
    copyUrl: 'Kopier URL',
    shareCurrentPage: 'Del nuværende side',
    shareCurrentPosition: 'Del nuværende position',
    copyUrlToClipboard: 'URL kopieret til udklipsholder',
    tooltips: {
        zoomOut: 'Zoom ud',
        zoomIn: 'Zoom ind',
        config: 'Indstillinger',
        tableOfContents: 'Indholdsfortegnelse',
        search: 'Søg',
        highlights: 'Fremhævninger',
        notebook: 'Notesbog',
        listen: 'Lyt',
        bookmarks: 'Bogmærker',
        openThumbnails: 'Miniaturer',
        closeThumbnails: 'Luk miniaturer',
        download: 'Offline-adgang',
        share: 'Del',
        prev: 'Forrige',
        next: 'Næste',
        close: 'Luk',
        back: 'Tilbage',
        themeTitle: 'Udseende',
        themeLight: 'Lys',
        themeDark: 'Mørk',
        themeCream: 'Creme',
        themeSepia: 'Sepia',
        themeCyan: 'Cyan',
        themeHighContrast: 'Høj kontrast',
        themeHighContrastDark: 'Høj kontrast mørk',
        clear: 'Ryd',
        citation: 'Citat',
        dictionary: 'Ordbog',
        aiIntegrations: 'AI-assistent (Beta)',
        aiAction:
            'Dette værktøj bruger AI, så der kan være unøjagtige oplysninger. Flere forbedringer kommer snart! Hvad synes du? Brug ikonerne nedenfor til at dele dine tanker.',
        translate: 'Oversæt',
        about: 'Om',
        rewind: 'Spol tilbage',
        forward: 'Spol frem',
        createNote: 'Opret en note',
        createHighlight: 'Fremhæv',
        deleteHighlight: 'Slet fremhævning',
        help: 'Hjælp',
        lists: 'Lister',
        copy: 'Kopier',
        goodResponse: 'Godt svar',
        badResponse: 'Dårligt svar',
        ai: 'AI-assistent',
        moreActions: 'Flere handlinger',
        moreOptions: 'Flere muligheder',
        play: 'Afspil',
        pause: 'Pause',
        seekPosition: 'Sporposition',
        zoomReset: 'Nulstil zoom',
        smartZoom: 'Smart Zoom',
        themeSystem: 'Systemtema',
        searchInBook: 'Søg i bogen',
        pageSlider: 'Sidenavigation',
    },
    save: 'Gem',
    delete: 'Slet',
    cancel: 'Annuller',
    confirmDelete: {
        title: 'Slet note',
        message: 'Er du sikker på, at du vil slette denne note? Denne handling kan ikke fortrydes.',
    },
    confirmResetSettings: {
        title: 'Nulstil indstillinger',
        message: 'Alle visuelle indstillinger nulstilles til standardværdierne.',
    },
    resetSettings: 'Nulstil indstillinger',
    writeNote: 'Skriv en note',
    speakNow: 'Tal nu',
    listeningSpeech: 'Lytter',
    share: {
        copyShare: 'Kopier og del',
        qrCodeTitle: 'QR-kode',
        scanQr: 'Scan QR-koden med din WeChat-app',
        copyLink: 'Kopier publikationens URL',
        copy: 'Kopier',
        copied: 'kopieret!',
        openWechat: 'Åbn WeChat-app',
        openingWechat: 'Åbner WeChat-app...',
        sendCopiedUrl: 'Send kopieret URL til en kontakt',
    },
    playing: 'Afspiller',
    buyNow: 'Køb nu',
    buyNowText: 'Få den fulde version.',
    preview: 'Prøve',
    changeLayoutNotAllowed: 'Indholdet tillader ikke at ændre sidelayoutet',
    nativeTtsLang: {
        'en-US': 'Engelsk (USA)',
        'en-GB': 'Engelsk (Storbritannien)',
        'en-scotland': 'Engelsk (Skotland)',
        'en-AU': 'Engelsk (Australien)',
        'en-IE': 'Engelsk (Irland)',
        'en-IN': 'Engelsk (Indien)',
        'en-ZA': 'Engelsk (Sydafrika)',
        en: 'Engelsk',
        'es-AR': 'Spansk (Argentina)',
        'es-ES': 'Spansk (Spanien)',
        'es-MX': 'Spansk (Mexico)',
        'es-US': 'Spansk (USA)',
        es: 'Spansk',
        'it-IT': 'Italiensk (Italien)',
        it: 'Italiensk',
        'pt-PT': 'Portugisisk (Portugal)',
        'pt-BR': 'Portugisisk (Brasilien)',
        pt: 'Portugisisk',
        'fr-CA': 'Fransk (Canada)',
        'fr-FR': 'Fransk (Frankrig)',
        fr: 'Fransk',
        pl: 'Polsk',
        'pl-PL': 'Polsk (Polen)',
        'da-DK': 'Dansk (Danmark)',
        da: 'Dansk',
    },
    promoteApp: {
        downloadAppStore: 'Download i App Store',
        downloadPlayStore: 'Hent den på Google Play',
        title_read: 'Tag din læsning med dig overalt med',
        title_audio: 'Tag dine lydbøger med dig overalt med',
        text: 'Få adgang til dit indhold når og hvordan du vil, uden internetforbindelse, på den enhed du foretrækker. Download vores app!',
        title_first_part: 'Med',
        title_second_part: 'tag din læsning med dig overalt',
    },
    dictionary: 'Ordbog',
    selectionTooLongLine1: 'Markeringen har for mange ord.',
    selectionTooLongLine2: 'Prøv at markere op til 5 ord.',
    dictionaryValidation: {
        message: 'Du har valgt {count} ord.\nPrøv venligst at vælge op til {max} ord.',
    },
    translateValidation: {
        message: 'Du har valgt {count} tegn.\nPrøv venligst at vælge op til {max} tegn.',
    },
    ttsValidation: {
        message: 'Du har valgt {count} tegn.\nPrøv venligst at vælge op til {max} tegn.',
    },
    aiValidation: {
        message: 'Du har valgt {count} tegn.\nVælg venligst mellem {min} og {max} tegn.',
    },
    alreadyPurchased: 'Allerede købt?',
    logIn: 'Log ind',
    addToAList: 'Føj til en liste',
    lists: 'Lister',
    nextSection: 'Næste afsnit',
    prevSection: 'Forrige afsnit',
    new: 'Ny',
    skipLinks: {
        navLabel: 'Hurtige adgangslinks',
        showControls: 'Vis kontrolelementer',
    },
    accessibility: {
        textSelected: '{count} tegn valgt. Valgværktøjer tilgængelige.',
        pageChanged: 'Side {current} af {total}',
    },
};
